import { createModule } from '../../createModule';
export const createMarketdataAPI = createModule(({ http }) => {
    return {
        getPrices: async (params) => {
            return await http.get('/v2/marketdata/prices', { params });
        },
        getJobs: async () => {
            return await http.get('/v2/marketdata/jobs');
        },
        runJobs: async (body) => {
            return await http.post('/v2/marketdata/run-market-data-jobs', {
                body,
            });
        },
        getQueue: async () => {
            return await http.get('/v2/marketdata/queue');
        },
    };
});
